import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const useSaveScrollPosition = (positionSelector, saveAction, archived) => {
    const savedPos = useSelector((state) => positionSelector(state, { archived }));
    const dispatch = useDispatch();
    useEffect(() => {
        window.scrollTo(0, +savedPos);
        return () => {
            dispatch(saveAction(Math.round(window.scrollY), archived));
        };
    }, []);
};
export default useSaveScrollPosition;
